"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceUpdate = void 0;
var react_1 = require("react");
function useForceUpdate() {
    var _a = react_1.useState(false), value = _a[0], setValue = _a[1]; // integer state
    return function () { return setValue(function (value) { return !value; }); }; // update the state to force render
}
exports.useForceUpdate = useForceUpdate;
